import { Box, styled } from '@mui/material'
import { spacing } from '@/styles/designTokens'

// Flex column so StyledContentBox (flex:1; overflow:auto) and StyledFooterBox
// sit correctly within the modal's flex chain after replacing the transparent fragment.
export const StyledFormRoot = styled('form')({
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
	overflow: 'hidden',
})

export const StyledFormInputsWrapper = styled(Box)({
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	gap: `${spacing.lg}px`,
	alignItems: 'flex-start',
})

export const StyledLoadingContent = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	gap: spacing.sm,
	justifyContent: 'center',
})
